export default __webpack_public_path__ + "static/logo-3cb78d6ba32a15287a8f539b04d6c94c.webp";